<template>
<section>
<Breadcrumbs main="Standing Order" title="Manage Standing Orders" />
<section id="RolesList" class="container-fluid" v-if="getStandingOrders">
    <div class="row match-height">
        <div class="col-lg-12">
            <div class="card animated fadeIn">
                <div class="card-header">
                    <h5>All Standing Orders</h5>
                    <span>Manage existing Standing Orders. Use the filters to search list.</span>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table display table-striped" id="StandingOrderTable">
                            <thead>
                                <tr>
                                    <th>Start Date</th>
                                    <th>Source Account</th>
                                    <th>Destination Account Number</th>
                                    <th>Destination Bank Name</th>
                                    <th>Credit Account Name</th>
                                    <th>Amount</th>
                                    <th>Frequency</th>
                                    <th>Number Of Occurrences</th>
                                    <th>Narration</th>
                                    <th>Create Date</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody v-for="standingOrder in sortedStandingOrders" :key="standingOrder.id">
                                <tr>
                                    <td>{{standingOrder.startDate | moment}}</td>
                                    <td>{{standingOrder.debitAccountNumber}}</td>
                                    <td>{{standingOrder.creditAccountNumber}}</td>
                                    <td>{{standingOrder.destinationBankName}}</td>
                                    <td>{{standingOrder.creditAccountName}}</td>
                                    <td>NGN{{new Intl.NumberFormat('en-NG', {}).format(standingOrder.amount)}}</td>
                                    <td>{{standingOrder.frequency === 1 ? 'One-off' : standingOrder.frequency === 2 ? 'Daily' : standingOrder.frequency === 3 ? 'Weekly' : standingOrder.frequency === 4 ? 'Monthly' : standingOrder.frequency === 5 ? 'Quaterly' : 'Yearly'}}</td>
                                    <td>{{standingOrder.numberOfOccurence}}</td>
                                    <td>{{standingOrder.narration ? standingOrder.narration : 'N/A'}}</td>
                                    <td>{{standingOrder.createdDate | moment}}</td>
                                    <td :class="standingOrder.status === 1 ? 'text-success' : 'text-danger'">{{standingOrder.status === 1 ? 'ACTIVE' : 'INACTIVE'}}</td>
                                    <td data-toggle="modal" @click="getStandingOrdersDetails(standingOrder)" data-target="#standingOrderModal" data-placement="top" title="View" ><i class='fa fa-eye primary-color'></i></td>
                                    <td v-if="standingOrder.status === 1" style="cursor:pointer" data-toggle="modal" @click="stopStandingOrder(standingOrder.id)" data-target="#stopStandingInstructionModalCenter" data-placement="top" title="Stop Instruction" ><i class='fa fa-times-circle primary-color'></i></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-if="sortedStandingOrders.length === 0" class="text-center mt-4 text-danger">No standing orders</div>
                </div>
            </div>
        </div>

    </div>
</section>
<div v-else class="loader-12"></div>
<!-- Modal to view standing order Details -->
<div class="modal fade" id="standingOrderModal" tabindex="-1" role="dialog" aria-labelledby="transactionDetailsModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addUserCenterTitle" style="font-size: 18px">Standing Order Details</h5>
                <button class="close text-dark" type="button" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card-content">
                            <div id="transactionDetailsBody" class="align-content-center align-items-center justify-content-center p-2">
                                <!-- Transaction Details will be loaded here -->
                                <h5 style="font-size: 17px" class="text-dark">Schedule for Standing Order: {{newStandingOrder.creditAccountNumber}}  ({{newStandingOrder.destinationBankName ? newStandingOrder.destinationBankName : 'N/A'}})</h5>
                                <h6 v-if="isLoading" class="text-success text-center py-3"><i class="fa fa-refresh fa-spin"></i> Please wait...</h6>
                                <div  v-else class="table-responsive">
                                  <table class="table table-striped">
                                   <tbody>
                                        <tr v-for="schedule in sortedSchedule" :key="schedule.id">
                                            <td>Amount <span class="font-weight-bold"><br>N{{new Intl.NumberFormat('en-NG', {}).format(newStandingOrder.amount)}}</span></td>
                                            <td>Due Date <span class="font-weight-bold"><br>{{schedule.processingDate | moment}}</span></td>
                                            <td>Reason <span class="font-weight-bold"><br>{{schedule.notes ? schedule.notes : 'N/A'}}</span></td>
                                            <td>Status <span class="font-weight-bold" :class="schedule.status === 0 ? 'text-success' : schedule.status === 1 ? 'text-danger' : schedule.status === 3 ? 'text-warning' : schedule.status === 4 ? 'text-danger' : 'text-info'"> <br>
                                            {{schedule.status === 0 ? 'Successful' : schedule.status === 1 ? 'Failed' : schedule.status === 3 ? 'Pending' : schedule.status === 4 ? 'Stopped' : 'Processing'}}</span>
                                            </td>
                                            <td v-if="schedule.status === 3" data-placement="top" data-toggle="modal" data-target="#stopScheduleModal" @click="stopSchedule(schedule.id)" title="Stop Schedule"><span style="cursor:pointer" class="text-danger"><i class='fa fa-times-circle primary-color mr-2'></i>Stop</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- stop standing order modal -->
<div class="modal fade" id="stopStandingInstructionModalCenter" tabindex="-1" role="dialog" aria-labelledby="stopStandingInstructionCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header bg-primary">
                <h5 class="modal-title" id="stopStandingInstructionCenterTitle">Stop Standing Order</h5>
                <button class="close text-white" @click="resetForm" type="button" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body p-4">
                <div class="row">
                    <div class="col-md-12">
                        <form class="form is-validated">
                            <div class="form-body">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="text-dark" for="stopReason">Reason for stopping</label>
                                        <textarea class="form-control" id="stopReason" rows="3" v-model="form.description" placeholder="Reason for stopping" required></textarea>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="mb-3 row">
                                            <div class="col-sm-12 col-xl-12">
                                                <label class="text-dark">Enter Transaction Pin to continue.</label>
                                                <input :type="type" @keypress="isNumber" @paste.prevent maxlength="4" v-model="form.transactionPin" id="StopTransactionPin" name="Password" class="form-control" placeholder="Enter Transaction Pin" required>
                                                <div @click="showPin" class="show-hide"><span :class="type === 'password' ? 'show' : 'hide'"></span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col-12">
                                        <button type="button" id="btnSubmit" @click="deleteStandingOrder" class="btn btn-primary mr-2">
                                            <div v-if="loading">
                                                <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                                            </div>
                                            <div v-else>Submit</div>
                                        </button>
                                        <button type="button" @click="resetForm" data-dismiss="modal" id="btnCancelStandingInstructions" class="btn btn-outline-danger">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- stop schedule order modal -->
<div class="modal fade" id="stopScheduleModal" tabindex="-1" role="dialog" aria-labelledby="stopScheduleModalCenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header bg-primary">
                <h5 class="modal-title" id="stopScheduleModalCenter">Stop Standing Order Schedule</h5>
                <button class="close text-white" @click="resetForm" type="button" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body p-4">
                <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                          <label class="text-dark" for="stopReason">Reason for stopping</label>
                          <textarea class="form-control" id="stopReason" rows="3" v-model="form.description" placeholder="Reason for stopping" required></textarea>
                      </div>
                    </div>
                    <div class="col-md-12">
                        <form class="form is-validated" id="StopStandingInstructions_Form">
                            <div class="form-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="mb-3 row">
                                            <div class="col-sm-12 col-xl-12">
                                                <label class="text-dark">Enter Transaction Pin to continue.</label>
                                                <input :type="type" @keypress="isNumber" @paste.prevent maxlength="4" v-model="form.transactionPin" id="schedulePin" class="form-control" placeholder="Enter Transaction Pin" required>
                                                <div @click="showPin" class="show-hide"><span :class="type === 'password' ? 'show' : 'hide'"></span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col-12">
                                        <button type="button" @click="deleteSchedule" class="btn btn-primary mr-2">
                                            <div v-if="loading">
                                                <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                                            </div>
                                            <div v-else>Submit</div>
                                        </button>
                                        <button @click="resetForm" type="button" data-dismiss="modal" class="btn btn-outline-danger">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</section>
</template>
<script>
  // import Datepicker from 'vuejs-datepicker';
  import { mapState } from 'vuex';
  import moment from 'moment';
  import $ from 'jquery';
  import { decrypt } from '../../_services/encryption';
  export default {
    components: {
      // Datepicker
    },
    filters: {
      moment: function (date) {
        return moment(date).format('YYYY-MM-DD hh:mm:ss a');
      }
    },
    data:() => ({
      format: 'yyyy-MM-dd',
      form: {
        description: '',
        standingInstructionId: '',
        scheduleId: '',
        transactionPin: '',
        platform: 1,
      },
      loading: false,
      isLoading: false,
      type: 'password',
      newStandingOrder: {
        title: 'schedule',
        amount: '',
        creditAccountNumber: '',
        status: '',
        schedule: [],
        reason: '',
        destinationBankName: '',
      }
    }),
    computed:{
      ...mapState({
        userAccounts: state => state.dashboard.dashboardData.accounts,
        allBanks: state => state.beneficiaries.allBanks,
        getStandingOrders: state => state.standingOrders.standingOrders.standingInstructions,
        getSchedule: state => state.standingOrders.standingInstructionSchedule,
      }),
      // sort standing orders by date
      sortedStandingOrders: function () {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return this.getStandingOrders.sort(function (a, b) {
          return new Date(b.createdDate) - new Date(a.createdDate);
        });
      },
      sortedSchedule: function () {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return this.getSchedule.sort(function (a, b) {
          return new Date(a.processingDate) - new Date(b.processingDate);
        });
      },
    },
    mounted() {
      this.$store.dispatch('beneficiaries/getAllBanks');
      try {
        this.loading = true;
        this.$store.dispatch('standingOrders/getStandingOrders');
        this.loading = false;
      } catch (error) {
        this.loading = false;
        const decryptedError = decrypt(error.response.data);
        const objError = JSON.parse(decryptedError);
        this.$swal({
          type: 'error',
          title: 'Oops...',
          text: objError.errors[0],
        });
      }
      
    },
    methods:{
      resetForm() {
        this.form.description = '';
        this.form.transactionPin = '';
      },
      isNumber(event) {
        // prevent user to enter non-numeric value
        if (event.keyCode < 48 || event.keyCode > 57) {
          event.returnValue = false;
        }
      },
      reset() {
        this.form.standingInstructionId = '';
        this.form.description = '';
        this.form.scheduleId = '';
        this.form.transactionPin = '';
        this.form.platform = 1;
      },
      showPin() {
        this.type = this.type === 'password' ? 'text' : 'password';
      },
      async getStandingOrdersDetails(value) {
        this.isLoading = true;
        try {
          this.isLoading = false;
          await this.$store.dispatch('standingOrders/getStandingInstructionSchedule', value.id);
        } catch(error) {
          this.isLoading = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: objError.errors[0],
          });
        }
        this.newStandingOrder.creditAccountNumber = value.creditAccountNumber;
        this.newStandingOrder.destinationBankName = value.destinationBankName;
        this.newStandingOrder.amount = value.amount;
        this.form.standingInstructionId = value.id;
      },
      stopSchedule(value) {
        this.form.scheduleId = value;
        $('#standingOrderModal').modal('hide');
      },
      stopStandingOrder(value) {
        this.form.standingInstructionId = value;
      },
      deleteSchedule() {
        if(this.form.transactionPin === '') {
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: 'Please enter your transaction pin',
          });
          return;
        } else {
          this.loading = true;
          this.$store.dispatch('standingOrders/stopSchedule', this.form).then(() => {
            this.loading = false;
            this.$swal({
              type: 'success',
              title: 'Success',
              text: 'Schedule Stopped successfully',
            });
            this.$store.dispatch('standingOrders/getStandingOrders');
            $('#stopScheduleModal').modal('hide');
            this.form.transactionPin = '';
            this.form.description = '';
          }).catch(error => {
            this.loading = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$swal({
              type: 'error',
              title: 'Oops...',
              text: objError.errors[0],
            });
          });
        }
      },
      deleteStandingOrder() {
        if(this.form.transactionPin === '') {
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: 'Please enter your transaction pin',
          });
          return;
        } else {
          this.loading = true;
          this.$store.dispatch('standingOrders/stopStandingOrder', this.form).then(() => {
            this.loading = false;
            this.$swal({
              type: 'success',
              title: 'Success',
              text: 'Standing Order has been Stopped successfully',
            });
            this.$store.dispatch('standingOrders/getStandingOrders');
            $('#stopStandingInstructionModalCenter').modal('hide');
            this.form.transactionPin = '';
            this.form.description = '';
          }).catch(error => {
            this.loading = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$swal({
              type: 'error',
              title: 'Oops...',
              text: objError.errors[0],
            });
          });
        }
      }
    }
  };
</script>
<style scoped>
.table-header {
    display: flex;
    justify-content: space-between;
    width: 200px;
}
.primary-color {
  color: #E41613;
  cursor: pointer;
}
</style>